












import { NextQuery } from '@empathy/search-types';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { EVENTS } from '../../../bus/events.const';

@Component
export default class NextQueryComponent extends Vue {
  @Prop({ required: true })
  private item: NextQuery;

  selectNextQuery() {
    this.$x.emit(EVENTS.SelectNextQuery, this.item);
  }
}
